<template>
  <BModal
    :active.sync="showModalConfirm"
    :on-cancel="cancelModal"
    has-modal-card
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
  >
    <div class="modal-card modal-confirm" style="width: auto">
      <section class="modal-card-body">
        <div class="container-header">
          <div class="container-header__cont-img"><img src="https://golstatsimages.blob.core.windows.net/todoelfut/trash.png" /></div>
          <div class="container-header__title">{{ title }}</div>
          <div class="close-button" @click="clickClose">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" alt="close" width="48" />
          </div>
        </div>

        <div class="btn-container">
          <p class="question">{{ question }}</p>
          <div class="left-button">
            <div class="btn cancel-button" @click="cancelModal">Cancelar</div>
          </div>
          <div class="right-button">
            <div class="confirm-button" @click="confirm">
              Borrar
            </div>
          </div>
        </div>
      </section>
    </div>
  </BModal>
</template>

<script>
import { BModal } from 'buefy/dist/esm/modal';

export default {
  name: 'ConfirmDeleteInPlaylist',
  components: {
    BModal,
  },
  props: {
    showModalConfirm: {
      type: Boolean,
      required: true,
    },
    question: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      disabledConfirm: false,
    };
  },
  watch: {
    showModalConfirm(newValue) {
      window.parent.postMessage({ message: 'modalShown', isShown: newValue }, '*');
    },
  },
  methods: {
    clickClose() {
      this.$emit('onCancelPlaylist');
    },
    async confirm() {
      if (!this.disabledConfirm) {
        this.disabledConfirm = true;
        await this.$emit('onConfirmPlaylist');
        setTimeout(() => {
          this.cancelModal();
          this.disabledConfirm = false;
        }, 500);
      }
    },
    cancelModal() {
      this.$emit('onCancelPlaylist');
    },
  },
};
</script>

<style lang="scss" scoped>
.container-header {
  height: 46px;
  line-height: 46px;
  width: 100%;
  display: inline-flex;
  justify-content: left;
  border-bottom: 1px dotted #878e93;
  &__title {
    font-size: 18px;
    margin-left: 5.5px;
  }
  &__cont-img {
    img {
      margin-top: 3px;
    }
  }
}
.close-button {
  display: flex;
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 18px;
  top: 19px;
}
.modal-card-body {
  padding: 5px 5px 0px 5px !important;
}
.modal-confirm {
  width: 428px;
  margin: 0px 0px 0px 0px;
  padding: 0px 13px 25px;
  border-radius: 10px;
  box-shadow: 0 17px 32px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.question {
  width: 355px;
  height: 50px;
  margin: 20px 18px 32px 19px;
  font-family: 'Avenir-Medium';
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: -0.42px;
  text-align: center;
  color: #132839;
  grid-area: question;
  grid-column: 1 / 3;
  grid-row: 1 / 1;
}

.btn-container {
  display: grid;
  margin: 0 auto;
  width: fit-content;
}

.disabled-btn {
  background-color: #979797 !important;
  cursor: not-allowed !important;
}
.confirm-button {
  width: 179px;
}
.cancel-button {
  width: 179px;
}

.confirm-button,
.cancel-button {
  height: 56px;
  font-family: 'Circular-Std-Bold';
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  border-radius: 25px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.11px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

.left-button,
.right-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancel-button {
  border: solid 1px #979797;
  color: #494a4b;
}
.confirm-button {
  background-color: #ee6b83;
  color: #ffffff;
}

@media screen and (max-width: 768px) {
  .modal-confirm {
    width: 428px !important;
    margin: 0px 0px 0px 0px !important;
    padding: 0px 13px 25px !important;
    margin: 0 auto !important;
    text-align: center;
  }
}
@media screen and (max-width: 530px) {
  .container-header {
    height: 46px;
    line-height: 46px;
    width: 100%;
    display: inline-flex;
    justify-content: left;
    border-bottom: 1px dotted #878e93;
    &__title {
      font-size: 18px;
      margin-left: 5.5px;
    }
    &__cont-img {
      img {
        margin-top: 3px;
      }
    }
  }
  .modal-card-body {
    padding: 5px 5px 0px 5px !important;
  }
  .question {
    width: 296px !important;
    font-size: 19px !important;
  }
  .modal-confirm {
    width: 396px !important;
    margin: auto !important;
    margin: 0px 0px 0px 0px;
    padding: 0px 13px 25px;
  }

  .cancel-button {
    width: 155px;
    font-size: 20px;
    height: 43px;
  }
  .confirm-button {
    width: 155px;
    height: 43px;
    font-size: 20px;
  }
}
@media screen and (max-width: 420px) {
  .modal-confirm {
    width: 296px !important;
    margin: auto !important;
  }
  .question {
    width: 206px !important;
    height: 30px !important;
    font-size: 13px !important;
  }
  .cancel-button {
    width: 110px;
    height: 35px;
    font-size: 14px;
  }
  .confirm-button {
    width: 110px;
    height: 35px;
    font-size: 14px;
  }
}
</style>
